class window.FeedbackAdmin
  constructor: ->

    @updateQuestionForm = $('.js-update-questions-form')
    @updateAnswerForm = $('.js-update-answer-form')
    @createAnswerForm = $('.js-create-answer-form')
    @createMail = $('.js-create-mail-button')
    @historyItemsContainer = $('.js-history-items-container')
    @statusHistoryContainer = $('.js-admin-virtual-reception-statuses-container')
    @initAdminQuestion()

  initAdminQuestion: ->
    self = this
    @updateQuestionForm.submit (event) ->
      event.preventDefault()
      dataInputs = self.updateQuestionForm.serialize()
      $.ajax
        url: $(this).attr('action') # Путь до скрипта поиска
        data: dataInputs
        type: 'post'
        dataType: 'json'
        error: (error) ->
          $('.base-input-wrapper--error').removeClass('base-input-wrapper--error')
          $('label.base-error').remove()
          errors = $.parseJSON(error['responseText'])
          $.each errors.errors, (key,value) ->
            $("input[name='#{key}']").parent().addClass("base-input-wrapper--error")
            $("input[name='#{key}']").after("<label class=\"base-error\">#{value}</label>")


        success: (result) ->
          if result.result == true
            $('.base-input-wrapper--error').removeClass('base-input-wrapper--error')
            $('label.base-error').remove()

            if result.is_new_status
              unless result.status == undefined || result.status == null
                self.appendNewStatus(result.status)
            else
              self.statusHistoryContainer.children().last().remove()
              self.appendNewStatus(result.status)

            $('.js-update-questions-form-status').fadeIn()
            setTimeout (-> $('.js-update-questions-form-status').fadeOut()), 3500
          else
            alert('обновление не удалось')

    @updateAnswerForm.submit (event) ->
      event.preventDefault()
      dataInputs = self.updateAnswerForm.serializeArray()
      $.ajax
        url: $(this).attr('action') # Путь до скрипта поиска
        files: $('.js-update-answer-file')[0]
        data: dataInputs
        iframe: true
        type: 'post'
        dataType: 'json'
        success: (result) ->
          if result.errors == undefined
            $('.js-update-answer-form-status').fadeIn()
            setTimeout (-> $('.js-update-answer-form-status').fadeOut()), 3500
            self.updateAnswerFile(result)
            $("input[name='ANSWER_ID']").val(result.ID)
          else
            $('input.error').removeClass('error')
            $('label.error').remove()
            $.each result.errors, (key,value) ->
              $("input[name='#{key}']").addClass("error")
              $("input[name='#{key}']").after("<label class=\"error\" style=\"display: inline-block\">#{value}</label>")

    @createAnswerForm.submit (event) ->
      event.preventDefault()
      dataInputs = self.createAnswerForm.serializeArray()
      $.ajax
        url: $(this).attr('action') # Путь до скрипта поиска
        files: $('.js-answer-file')[0]
        data: dataInputs
        iframe: true
        type: 'post'
        processData: false
        dataType: 'json'
        success: (result) ->
          if result.errors == undefined
            $('.js-create-answer-form-status').fadeIn()
            setTimeout (-> $('.js-create-answer-form-status').fadeOut()), 3500
            self.updateAnswerFile(result)
            $("input[name='ANSWER_ID']").val(result.ID)
          else
            $('input.error').removeClass('error')
            $('label.error').remove()
            $.each result.errors, (key,value) ->
              $("input[name='#{key}']").addClass("error")
              $("input[name='#{key}']").after("<label class=\"error\" style=\"display: inline-block\">#{value}</label>")

    @createMail.submit (event) ->
      event.preventDefault()
      dataInputs = self.createMail.serializeArray()
      $.ajax
        url: $(this).attr('action') # Путь до скрипта поиска
        data: dataInputs
        type: 'post'
        dataType: 'html'

        error: (error) ->
          $('.js-create-mail-button label.error').remove()
          errors = $.parseJSON(error['responseText'])
          $.each errors.errors, (key,value) ->
            $('.js-create-mail-button').append("<label class=\"error\">#{value}</label>")

        success: (result) ->
          $('.js-create-mail-button label.error').remove()
          $('.js-create-mail-button-status').fadeIn()
          setTimeout (-> $('.js-create-mail-button-status').fadeOut()), 3500
          self.updateHistoryAnswerItem(result)



  updateHistoryAnswerItem: (result) ->

    objJson = $.parseJSON(result)
    newHistoryItemHtml = """
                          <div class="history-answer-item">
                          <label class="base-label email-field-title ">Время отправки письма: #{objJson['DATE_CREATE']}</label><br>
                          <label class="base-label email-field-title">Статус обращения: #{objJson['NAME']}</label><br>
                        """
    if objJson['NAME'] == 'Направлено на рассмотрение'
      newHistoryItemHtml = newHistoryItemHtml + "<label class=\"base-label email-field-title\">Куда направлено: #{objJson['PREVIEW_TEXT']}</label>"
    else if objJson['PROPERTIES']['HISTORY_FILE']['VALUE']['FILE_NAME'] != undefined
      fileInfo = objJson['PROPERTIES']['HISTORY_FILE']['VALUE']
      newHistoryItemHtml = newHistoryItemHtml +
                          "<label class=\"base-label email-field-title\">Файл:<a target=\"_blank\" href=\"/upload/#{fileInfo['SUBDIR']}/#{fileInfo['FILE_NAME']}\">#{fileInfo['FILE_NAME']}</a></label>"


    newHistoryItemHtml = newHistoryItemHtml + '</div><br><hr><br>'

    @historyItemsContainer.prepend(newHistoryItemHtml)

  updateAnswerFile: (result) ->
    fileInfo = result['PROPERTIES']['ANSWER_FILE']['VALUE']
    $('.js-answer-update-file').attr("href", "/upload/#{fileInfo['SUBDIR']}/#{fileInfo['FILE_NAME']}")
    $('.js-answer-update-file').text(fileInfo['FILE_NAME'])

  appendNewStatus: (element) ->
    elementBlock = '<div class="js-admin-virtual-reception-status-element">'
    elementBlock += """
      <div class="virtual-reception-managment__row">
          <div class="virtual-reception-managment__row-item">
              <strong>
                  ID: #{element.PARENT_ID}&nbsp;от&nbsp;#{element.PARENT_DATE_CREATE}
              </strong>
          </div>
    """
    unless ((element.PROPERTIES.NUMBER_REQUEST.VALUE == undefined && element.PROPERTIES.NUMBER_REQUEST.VALUE == null) || element.PROPERTIES.NUMBER_REQUEST.VALUE.length == 0) || ((element.PROPERTIES.DATA_FIXED_REQUEST.VALUE == undefined && element.PROPERTIES.DATA_FIXED_REQUEST.VALUE == null) || element.PROPERTIES.DATA_FIXED_REQUEST.VALUE.length == 0)
      elementBlock += """
        <div class="virtual-reception-managment__row-item">
            <strong>
                №&nbsp;#{element.PROPERTIES.NUMBER_REQUEST.VALUE}&nbsp;от&nbsp;#{element.PROPERTIES.DATA_FIXED_REQUEST.VALUE}
            </strong>
        </div>
      """
    elementBlock += """
        <div class="virtual-reception-managment__row-item">
              #{element.PROPERTIES.STATUS.VALUE}
        </div>
      </div>
    """
    unless (element.PROPERTIES.GO_TO.VALUE == undefined && element.PROPERTIES.GO_TO.VALUE == null) || element.PROPERTIES.GO_TO.VALUE.length == 0
      elementBlock += """
        <div class="virtual-reception-managment__row">
          <div class="virtual-reception-managment__row-item">
            #{element.PROPERTIES.GO_TO.VALUE}
          </div>
        </div>
      """
    if element.PROPERTIES.NOTIFIED.VALUE.length > 0 || element.PROPERTIES.DATE_NOTIFIED.VALUE.length > 0
      elementBlock += """
        <div class="virtual-reception-managment__row">
          <div class="virtual-reception-managment__row-item">
            <input type="checkbox" class="base-checkbox" #{if element.PROPERTIES.NOTIFIED.VALUE then 'checked'}>
            <label>#{element.PROPERTIES.NOTIFIED.NAME}</label>
          </div>
          <div class="virtual-reception-managment__row-item">
            #{element.PROPERTIES.DATE_NOTIFIED.VALUE}
          </div>
        </div>
      """
    elementBlock += "<hr></div>"
    @statusHistoryContainer.append($(elementBlock))


// WEBPACK FOOTER //
// ./assets/javascripts/app/feedback_admin.coffee